<template>
    <div class="video-audio-type-wrapper">
        <div class="d-inline-flex audio-type">
            <span>Please select the audio type for this video then hit submit.</span>
            <select v-model="audio_type" class="plain-select">
                <option disabled value="">Please select one</option>
                <option value="normal">Normal (stereo or mono)</option>
                <option value="5.1">5.1 + Stereo (8 channels)</option>
            </select>
        </div>
<!--        <div class="d-inline-flex video-type">-->
<!--            <span>Video Type</span>-->
<!--            <select v-model="video_type" class="plain-select">-->
<!--                <option disabled value="">Please select one</option>-->
<!--                <option value="normal">Normal</option>-->
<!--                <option>360</option>-->
<!--            </select>-->
<!--        </div>-->
        <div class="d-inline-flex button-type-wrapper">
            <button v-if="component_status" @click="applyChange()">Submit</button>
        </div>
        <div class="status-message-area" v-html="status_message"></div>
    </div>
</template>

<script>
import axios from 'axios';
    export default {
        components: {},
        props: {
            current_audio_type: String,
            current_video_type: String,
            vfoid: '',
            token: {
                type: String,
                default: "false"
            }
        },
        data() {
            return {
                component_status: 1,
                audio_type: this.current_audio_type,
                video_type: this.current_video_type,
                status_message: '',
                button_text: 'Submit'
            }
        },
        methods: {
            applyChange: function() {
                let that = this;
                that.component_status = 0;
                that.button_text = "Processing...";
                let actionUrl = `/video/update/${that.vfoid}`;
                if (that.token != 'false') {
                    actionUrl = `/video/update_token/${that.vfoid}`;
                }
                axios(
                    {
                        method: 'POST',
                        url: actionUrl,
                        data: {
                            audio_type: that.audio_type,
                            video_type: that.video_type,
                            status: 'Upload Submitted',
                            token: that.token
                        }
                    }).then(function(){
                        that.status_message = "Upload submitted. Ready for Review";
                        that.$emit('audioselected', that.vfoid)
                    }).catch(function (error) {
                    // handle error
                    that.status_message = "There was a problem updating this video.";
                    that.button_text = "Resubmit";
                    that.component_status = 1;
                    console.log('This is the error returned', error);
                });
            }
        }
    }
</script>
